import React from "react";
import { TabId, TabItem } from "../types/inspector.types";

interface TabBarProps {
  tabs: TabItem[];
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
  locked?: boolean;
}

export default function TabBar({ tabs, activeTab, onTabChange, locked = false }: TabBarProps) {
  return (
    <div className={`tabBar${locked ? " locked" : ""}`}>
      {tabs.map((tab) => {
        const isDisabled = locked && tab.id !== "submit";
        return (
          <div
            key={tab.id}
            className={`tab${activeTab === tab.id ? " active" : ""}${isDisabled ? " tabDisabled" : ""}`}
            onClick={() => !isDisabled && onTabChange(tab.id)}
            role="button"
            tabIndex={isDisabled ? -1 : 0}
            aria-selected={activeTab === tab.id}
            aria-disabled={isDisabled}
            onKeyDown={(e) => {
              if (!isDisabled && (e.key === "Enter" || e.key === " ")) onTabChange(tab.id);
            }}
          >
            <span className="tabIcon">{tab.icon}</span>
            {tab.label}
          </div>
        );
      })}
    </div>
  );
}
